import { useQuery } from '@tanstack/react-query';
import moment from 'moment';

import { useMemo } from 'react';
import { useAuthUserId } from '../../../../selectors/AuthSelectors';
import { useRestaurantId } from '../../../../selectors/RestaurantSelectors';
import { formatSystemDateTime } from '../../../shared/lib';
import { getActiveInPeriodRequest } from '../api';

export function getActiveInPeriodQueryKey(
  userId: number,
  restaurantId: number,
  from: moment.MomentInput | undefined = undefined,
  till: moment.MomentInput | undefined = undefined,
) {
  const items = [userId, 'restaurant', restaurantId, 'active_orders'];

  if (from) {
    items.push(formatSystemDateTime(from));
  }

  if (till) {
    items.push(formatSystemDateTime(till));
  }

  return items;
}

export function useActiveInPeriodQueryKey(
  from: moment.MomentInput,
  till: moment.MomentInput | undefined = undefined,
) {
  return getActiveInPeriodQueryKey(useAuthUserId(), useRestaurantId(), from, till);
}

export function useActiveInPeriod(from: number, till: number) {
  const f = moment(from);
  const t = moment(till);
  const restaurantId = useRestaurantId();
  // const queryKey = useActiveInPeriodQueryKey(f, t);
  const queryKey = useActiveInPeriodQueryKey(f);

  const {
    data: response,
    isLoading,
    isFetching,
    isFetched,
  } = useQuery({
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: false,
    queryKey,
    queryFn: () => {
      return getActiveInPeriodRequest(restaurantId, f, t);
    },
  });

  const data = useMemo(() => {
    if (!response?.data) {
      return null;
    }

    return response.data.filter((item) => item.tables?.length > 0);
  }, [response?.data]);

  return {
    isFetched,
    isLoading: isLoading || isFetching,
    data,
  };
}
